<template>
  <div class="gf_segment">
    <div class="gf_segment__group">
      <button
        v-for="opt in options"
        :key="opt.value"
        v-tooltip.top="opt.value"
        class="gf_segment__group-button"
        :class="[
          `${opt.icon && opt.icon.position ? 'gf_segment__icon--' + opt.icon.position : ''}`,
          { active: opt.value === val, 'gf_segment__icon--notext': !opt.label },
        ]"
        @click="changeValue(opt.value)">
        <i v-if="opt.icon && opt.icon.url" :class="['gf_segment__img', opt.icon.url]" />
        <span class="gf_segment__label">
          {{ opt.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GfSegment',
  props: {
    id: [String, Number],
    value: [String, Number, Boolean],
    options: {
      type: Array,
      required: false,
      default() {
        return [
          {
            label: 'Before',
            value: 'before',
            icon: {
              url: 'icon icon-ellipse',
              position: 'left',
            },
          },
          {
            label: 'After',
            value: 'after',
            icon: {
              url: 'icon icon-ellipse',
              position: 'right',
            },
          },
        ];
      },
    },
  },
  data() {
    return {
      val: '',
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.val = newValue;
      }
    },
  },
  created() {
    this.val = this.value;
  },
  methods: {
    setValue(value) {
      if (value !== this.val) {
        this.val = value;
      }
    },
    onChange() {
      this.$emit('onChange', {
        id: this.id,
        value: this.val,
      });
    },
    changeValue(val) {
      if (val !== this.val) {
        this.val = val;
        this.onChange();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gf_segment {
  &__group {
    display: flex;
    justify-content: space-between;

    &-button {
      flex: 1;
      cursor: pointer;
      padding: 8px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 11px;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: map-get($light-grey, '600');
      background: map-get($hybrid-shade-dark, '400');
      border: 1px;
      border-style: solid;
      border-color: map-get($hybrid-shade-dark, '200');
      border-right-width: 0.5px;
      border-left-width: 0.5px;

      &:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        border-left-width: 1px;
      }

      &:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        border-right-width: 1px;
      }

      &:hover {
        color: map-get($light-grey, '600');
      }

      &.active {
        background: map-get($hybrid-shade-dark, '200');
      }
    }

    .gf_segment__icon {
      &--left {
        flex-direction: row;

        .gf_segment__img {
          padding-right: 8px;
        }
      }

      &--right {
        flex-direction: row-reverse;

        .gf_segment__img {
          padding-left: 8px;
        }
      }

      &--notext {
        .gf_segment__img {
          padding: 0;
        }
      }
    }

    .gf_segment__img {
      font-size: 16px;
    }
  }
}
</style>
